import script from "./TaxCodeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxCodeCard.vue?vue&type=script&setup=true&lang=ts"

import "./TaxCodeCard.vue?vue&type=style&index=0&id=414b1273&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414b1273"]])

export default __exports__